import { AppState } from '../../app/state/AppState';
import { IExplorableItemTypeInfo } from '../../ts/models/resourceInfoParts';
import { AvailableActions } from '../state/AvailableActionsForEntityState';

export function selectAvailableActionsForEntity(state: AppState, entity: IExplorableItemTypeInfo): AvailableActions | undefined {

  const availableActionsState = state.availableActionsForEntities;
  if (!availableActionsState) {
    return undefined;
  }

  const entityInState = availableActionsState.entity;
  const actionsInStateAreForThisEntity: boolean =
      entityInState && entityInState.contentType === entity.contentType && entityInState.id === entity.id;

  return actionsInStateAreForThisEntity ? availableActionsState.availableActions: undefined;
}
